/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.15.0
 */

import { useMemo } from 'react';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { Button, LinkBlock } from '../../../../components/common';
import { IRootReducer } from '../../../../reducers/rootReducer';
import { icons } from '../../../../theme';
import { makeSelectOnboardingTranslation } from '../../../internationalization/intSelectors';
import { IOnboardingTranslation } from '../../../internationalization/types';
import { IOnboardingModalTranslation } from '../../../internationalization/types/modules/onboarding';
import Modal from '../../../modal/components/Modal';
import { ModalCenterStyled } from '../../../modal/components/styled/ModalCenterStyled';
import { EOnboardingModalId } from '../../types/onboardingTypes';
import { OnboardingModalImgStyled, OnboardingModalStyled } from './styled/OnboardingModalStyled';
import { useOnboardingModal } from './useOnboardingModal';


const OnboardingModalWelcome = ({
                                    translationOnboarding,
                                }: IConnectedProps) => {
    const {
        nextStep,
        showLater,
        skip,
    } = useOnboardingModal(EOnboardingModalId.modalWelcome);

    const tActions: IOnboardingModalTranslation['actions'] = useMemo(() => ({
        ...translationOnboarding.modal.default.actions,
        ...translationOnboarding.modal[EOnboardingModalId.modalWelcome].actions,
    }), [translationOnboarding]);

    return (
        <Modal dataName="onboarding-welcome-modal" width="535px">
            <OnboardingModalStyled>
                <ModalCenterStyled>
                    <Modal.Title>
                        {translationOnboarding.modal[EOnboardingModalId.modalWelcome].title}
                    </Modal.Title>
                    <OnboardingModalImgStyled src={icons.onboardingWelcomeStartModal}/>
                    <Modal.Text>
                        <div
                            className="onboarding-modal__text"
                            dangerouslySetInnerHTML={{
                                __html: translationOnboarding.modal[EOnboardingModalId.modalWelcome].text,
                            }}
                        />
                    </Modal.Text>

                    <Button
                        className="onboarding-modal__control"
                        kind="medium"
                        onClick={nextStep}
                    >
                        {tActions?.start}
                    </Button>
                    <Button
                        className="onboarding-modal__control"
                        kind="mediumOutline"
                        onClick={showLater}
                    >
                        {tActions?.showLater}
                    </Button>
                    <LinkBlock
                        className="onboarding-modal__control"
                        onClick={skip}
                    >
                        {tActions?.skip}
                    </LinkBlock>
                </ModalCenterStyled>
            </OnboardingModalStyled>
        </Modal>
    );
};

export interface IConnectedProps {
    translationOnboarding: IOnboardingTranslation;
}

export const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    translationOnboarding: makeSelectOnboardingTranslation(),
});

export default connect(mapStateToProps)(OnboardingModalWelcome);
